const m = require('minthril');
const { component } = require('../../../component');
const { Breadcrumbs } = require('../../../components/breadcrumbs');

const ReactSnapComparisonPage = component(() => ({
  view: () => m('article.panel.docs-page.react-snap-comparison', [
    m(Breadcrumbs, {
      items: [
        { label: 'Docs', href: '/docs' },
        { label: 'Comparisons', href: '/docs/comparisons' },
        { label: 'react-snap: Mid Engine Co' }
      ]
    }),
    m('h2', 'Building Mid Engine Co with react-snap'),
    m('p', [
      'Mid Engine Co is a custom Shopify storefront. With react-snap, a post-build process launches a real ' +
      'headless Chrome browser, crawls public links, and saves rendered pages as static HTML. The visitor’s ' +
      'React app still loads afterward and can hydrate that markup. ',
      m('a', {
        href: 'https://www.npmjs.com/package/react-snap',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, 'react-snap on npm'),
      ' · ',
      m('a', {
        href: 'https://github.com/stereobooster/react-snap',
        target: '_blank',
        rel: 'noopener noreferrer'
      }, 'project documentation')
    ]),
    m('p',
      'react-snap uses Headless Chrome and follows links from the root page. Its README shows adding a postbuild ' +
      'script and hydrating existing markup. It also documents optional AJAX caching, which stores JSON responses ' +
      'for the app to reuse during startup.'
    ),
    m('h3', 'Same rendering idea, different ownership'),
    m('p',
      'For the first working render, the effort can be similar: both run the SPA in a browser, wait for a useful ' +
      'public page, and produce HTML while leaving the visitor’s cart in the browser. The real difference is what ' +
      'happens after that first render. react-snap gives your build pipeline static HTML files; Spache operates ' +
      'the render, refresh, storage, and serving pipeline as a service.'
    ),
    m('div.react-snap-comparison__table-wrap', [
      m('table.react-snap-comparison__table', [
        m('thead', m('tr', [
          m('th', 'Responsibility'),
          m('th', 'With react-snap, your team owns…'),
          m('th', 'With Spache…')
        ])),
        m('tbody', [
          m('tr', [
            m('th', 'Rendering during a release'),
            m('td', 'Add the browser crawl to the post-build step and provide the runtime/resources it needs in CI.'),
            m('td', 'Automatic')
          ]),
          m('tr', [
            m('th', 'Finding routes'),
            m('td', 'The crawler follows links from its starting routes (default `/`); seed routes it cannot reach in `include`. Normal product links are usually sufficient.'),
            m('td', 'Automatic')
          ]),
          m('tr', [
            m('th', 'Keeping pages current after a Shopify update'),
            m('td', 'Trigger another snapshot build and deploy when product data changes—even if application code did not.'),
            m('td', 'Automatic, configurable')
          ]),
          m('tr', [
            m('th', 'Publishing and serving rendered HTML'),
            m('td', 'Publish generated route files and configure hosting so direct product URLs serve the snapshot rather than only the SPA fallback.'),
            m('td', 'Automatic')
          ]),
          m('tr', [
            m('th', 'Handling many routes'),
            m('td', 'Regenerate the configured route set as part of builds; build work grows with the pages being snapshotted.'),
            m('td', 'Automatic')
          ]),
          m('tr', [
            m('th', 'Reusing startup API responses'),
            m('td', 'Optionally enable react-snap AJAX caching for JSON responses.'),
            m('td', 'Automatic for JSON GET; configurable for non-GET')
          ]),
          m('tr', [
            m('th', 'Keeping the cart visitor-specific'),
            m('td', 'Both approaches serve a shared public snapshot, then let the browser app load the visitor’s own cart.'),
            m('td', 'Automatic')
          ])
        ])
      ])
    ]),
    m('p',
      'If your catalog changes only as part of regular releases and you already own a static deployment pipeline, ' +
      'react-snap can be a straightforward fit. If catalog changes should refresh rendered pages without rebuilding ' +
      'and redeploying the storefront—or you do not want to own generated HTML publication and route serving—Spache ' +
      'takes on that operational loop. That all-in-one render-to-refresh-to-serve lifecycle is the distinction.'
    )
  ])
}));

module.exports = { ReactSnapComparisonPage };
